module.exports = __webpack_public_path__ + "static/media/iphone 11 banner7.5cbe7b98.jpg";